$(function() {
    let buttons = $('.btn--selector');
    let targetList = getTargetList(buttons);

    buttons.each(function() {
        let $this = $(this),
            target = $this.attr('href');

        if (target.charAt(0) == '#') {
            target = target.substring(1);
        }

        $this.on('click', function(e) {
            e.preventDefault();

            $('.btn--selector.active').removeClass('active');
            $this.addClass('active');

            if (target == '.all') {
                // need all the targets of buttons here to fade them all back in
                $(targetList.join(', ')).addClass('active').fadeIn(200);
            } else {
                $(target).siblings().removeClass('active').fadeOut(200);
                $(target).addClass('active').fadeIn(200);
            }
        })
    })
})

function getTargetList(elementList) {
    let targets = [];

    elementList.each(function () {
        let target = $(this).attr('href');
        if (target != '.all') {
            if (target.charAt(0) == '#') {
                target = target.substring(1);
            }
            targets.push(target);
        }
    });

    return targets;
}